import React from 'react'
import {ButtonIcon} from 'ac_ui'
import {acPlay} from 'ac-icon'
import {isMacintosh} from './utils'

interface IExecuteButtonProps {
  isNew: boolean
  isExecuting: boolean
  onClick: (event?: any) => void
}

const ExecuteButton: React.FC<IExecuteButtonProps> = ({isNew, isExecuting, onClick}): React.ReactElement => {
  if (isNew) {
    return (
      <ButtonIcon
        iconPath={acPlay}
        title={'Выполнить'}
        disabled={isExecuting}
        onClick={onClick}
        isSquare
        color={'success'}
      />
    )
  }
  return (
    <button
      className={'task-toolbar-button task-execute-button' + (isExecuting ? ' executing' : '')}
      disabled={isExecuting}
      onClick={onClick}
      title={isMacintosh() ? 'CMD + ENTER' : 'CTRL + ENTER'}>
      <span>{isExecuting ? 'Выполняется' : 'Выполнить'}</span>
      <img className={'robot'} src={'/img/task/executionRobot.svg'} width={27} height={27} alt={'Робот'} />
      <img
        className={'robot-eye'}
        src={'/img/task/executionRobotEye.svg'}
        width={16}
        height={6}
        alt={'Робот выполняет'}
      />
    </button>
  )
}

export {ExecuteButton}
